module.exports = __webpack_public_path__ + "static/media/EmperorSeedChildrensBook.d244a58e.jpg";